import { useCoralTheme } from '@krakentech/coral';

const Users = ({ size = 32 }: { size?: number }) => {
  const { color } = useCoralTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M11.625 6C13.5938 6 15.4219 7.125 16.4766 8.8125C17.4609 10.5703 17.4609 12.75 16.4766 14.4375C15.4219 16.1953 13.5938 17.25 11.625 17.25C9.58594 17.25 7.75781 16.1953 6.70312 14.4375C5.71875 12.75 5.71875 10.5703 6.70312 8.8125C7.75781 7.125 9.58594 6 11.625 6ZM37.5 6C39.4688 6 41.2969 7.125 42.3516 8.8125C43.3359 10.5703 43.3359 12.75 42.3516 14.4375C41.2969 16.1953 39.4688 17.25 37.5 17.25C35.4609 17.25 33.6328 16.1953 32.5781 14.4375C31.5938 12.75 31.5938 10.5703 32.5781 8.8125C33.6328 7.125 35.4609 6 37.5 6ZM1.5 27.0234C1.5 22.875 4.80469 19.5 8.95312 19.5H11.9766C13.1016 19.5 14.1562 19.7812 15.1406 20.2031C15 20.6953 15 21.2578 15 21.75C15 24.4922 16.125 26.8828 18.0234 28.5C18.0234 28.5 18.0234 28.5 17.9531 28.5H2.97656C2.13281 28.5 1.5 27.8672 1.5 27.0234ZM29.9062 28.5C31.8047 26.8828 32.9297 24.4922 32.9297 21.75C32.9297 21.2578 32.9297 20.6953 32.8594 20.2031C33.7734 19.7812 34.8281 19.5 35.9531 19.5H38.9766C43.125 19.5 46.5 22.875 46.5 27.0234C46.5 27.8672 45.7969 28.5 44.9531 28.5H29.9062ZM17.25 21.75C17.25 19.3594 18.5156 17.1797 20.625 15.9141C22.6641 14.7188 25.2656 14.7188 27.375 15.9141C29.4141 17.1797 30.75 19.3594 30.75 21.75C30.75 24.2109 29.4141 26.3906 27.375 27.6562C25.2656 28.8516 22.6641 28.8516 20.625 27.6562C18.5156 26.3906 17.25 24.2109 17.25 21.75ZM10.5 40.1719C10.5 34.9688 14.6484 30.75 19.8516 30.75H28.0781C33.2812 30.75 37.5 34.9688 37.5 40.1719C37.5 41.1562 36.6562 42 35.6016 42H12.3281C11.2734 42 10.4297 41.2266 10.4297 40.1719H10.5Z"
        fill={color.primary.main}
      />
    </svg>
  );
};

export default Users;
